import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Heading, Text } from "@zillow/constellation-10";
import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { getCommaSeparatedNumber } from "../../utils/zhl-calculator.esm.js";
import { useLastValidDTIValues, getDefaultMortgagePayment } from "./DTICalculator.utils.esm.js";
import DTICostBreakdownTable from "./DTICostBreakdownTable.esm.js";
import { DTIMessage } from "./DTIMessage.esm.js";
import DTISlider from "./DTISlider.esm.js";
const DTIOutputTable = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidDTIValues(form);
  const debtsOut = lastValidValues.calculations.debtsOut;
  const monthlyIncome = lastValidValues.calculations.monthlyIncome;
  const [mortgagePayment, setMortgagePayment] = useState(getDefaultMortgagePayment(debtsOut, monthlyIncome));
  const currentDTI = (mortgagePayment + debtsOut) / monthlyIncome * 100;
  const roundedCurrentDTI = Math.round(currentDTI);
  const onSliderChange = (value) => {
    const newMortgage = value[1] - debtsOut >= 0 ? value[1] - debtsOut : 0;
    setMortgagePayment(newMortgage);
  };
  useEffect(() => {
    setMortgagePayment(getDefaultMortgagePayment(debtsOut, monthlyIncome));
  }, [debtsOut, monthlyIncome]);
  return /* @__PURE__ */ jsxs(Box, { css: {
    margin: "auto",
    textAlign: "center"
  }, children: [
    /* @__PURE__ */ jsxs(Heading, { level: 4, css: {
      marginBlockEnd: "tighter"
    }, "aria-live": "polite", "aria-atomic": "true", children: [
      "Debt-to-income ratio",
      /* @__PURE__ */ jsx(Text, { css: {
        display: "block",
        // v10 green.500 (#46a130) is a known palette shift from v8 green500 (#559E30)
        color: roundedCurrentDTI > 50 ? "orange.500" : "green.500",
        marginBlockEnd: "tighter"
      }, textStyle: "heading-sm", "data-color": roundedCurrentDTI > 50 ? "orange.500" : "green.500", children: Math.round(roundedCurrentDTI) + "%" })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      paddingBlockEnd: "tighter"
    }, children: [
      /* @__PURE__ */ jsx(Box, { css: {
        display: "block",
        mdDown: {
          display: "none"
        }
      }, children: /* @__PURE__ */ jsx(DTIMessage, { value: roundedCurrentDTI, defaultExpanded: true }) }),
      /* @__PURE__ */ jsx(Box, { css: {
        display: "block",
        md: {
          display: "none"
        }
      }, children: /* @__PURE__ */ jsx(DTIMessage, { value: roundedCurrentDTI }) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      maxWidth: "315px",
      marginTop: "layout.looser",
      marginInline: "auto",
      paddingBlock: "0",
      paddingInline: "loose",
      md: {
        maxWidth: "500px"
      }
    }, children: [
      /* @__PURE__ */ jsx(DTISlider, { monthlyIncome, debtsOut, mortgagePayment, inputValue: getCommaSeparatedNumber(debtsOut + mortgagePayment), onSliderChange }),
      /* @__PURE__ */ jsx(DTICostBreakdownTable, { debtsOut, monthlyIncome, mortgagePayment })
    ] })
  ] });
};
export {
  DTIOutputTable as default
};
